import * as React from 'react'

import type { SVGProps } from 'react'

const SvgGelIconChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    stroke="currentColor"
    fill="currentColor"
    strokeWidth={0}
    width="1em"
    height="1em"
    {...props}
  >
    <path
      d="M17.7 22.6.9 4.2v6.7L16 27.8 31.1 11V4.3L14.3 22.6h3.4zm0 0L.9 4.2v6.7L16 27.8 31.1 11V4.3L14.3 22.6h3.4z"
      stroke="none"
    />
  </svg>
)

export default SvgGelIconChevronDown
